import { useQuery } from '@tanstack/react-query';

// User settings are per-user (not per-organization), so the key is userId.
export function useUserSettingsQuery(api, userId, authToken) {
  return useQuery({
    queryKey: ['userSettings', userId],
    queryFn: () => api.settings.getUserSettings(userId, authToken),
    enabled: Boolean(api && userId && authToken),
  });
}

export function useDefaultSettingsQuery(api, authToken, { enabled = true } = {}) {
  return useQuery({
    queryKey: ['defaultSettings'],
    queryFn: () => api.settings.getDefaultSettings(authToken),
    enabled: Boolean(api && authToken && enabled),
  });
}
